import React, { Component } from "react";
import PropTypes from "prop-types";

import {
  Map as GoogleMap,
  InfoWindow,
  GoogleApiWrapper as googleApiWrapper,
  Marker
} from "google-maps-react";
import Geocode from "react-geocode";

import isObject from "lodash/isObject";

const API_KEY = "AIzaSyDQkciIqGujJBCuoa1mTTR4o9EcaZOgQL4";
Geocode.setApiKey(API_KEY);

class IrisMap extends Component {
  constructor(props) {
    super(props);
    this.state = {
      lng: 0,
      lat: 0,
      activeMarker: {},
      selectedPlace: {},
      showingInfoWindow: false
    };
  }

  componentDidMount = () => {
    this.getCoordinates(this.props.address);
  };

  onMarkerClick = (props, marker) =>
    this.setState({
      activeMarker: marker,
      selectedPlace: props,
      showingInfoWindow: true
    });

  onInfoWindowClose = () =>
    this.setState({
      activeMarker: null,
      showingInfoWindow: false
    });

  getCoordinates = (address) => {
    const addressString = Object.keys(address)
      .filter((key) => key !== "addr2" && key !== "country" && key !== "state")
      .map((key) => address[key])
      .join(",");

    Geocode.fromAddress(addressString).then(
      (response) => {
        const { lng, lat } = response.results[0].geometry.location;
        this.setState({ lng, lat });
      },
      (error) => {
        // eslint-disable-next-line no-console
        console.error(error);
      }
    );
  };

  render() {
    const { lat, lng } = this.state;

    return (
      <GoogleMap google={this.props.google} zoom={15} center={{ lat, lng }}>
        <Marker onClick={this.onMarkerClick} position={{ lat, lng }} />

        <InfoWindow
          marker={this.state.activeMarker}
          onClose={this.onInfoWindowClose}
          visible={this.state.showingInfoWindow}
        >
          <div>
            {Object.values(this.props.address)
              .filter(
                (value) =>
                  isObject(value) || (Array.isArray(value) && value.length)
              )
              .map((value) => (isObject(value) ? value.value : value))
              .join(", ")}
          </div>
        </InfoWindow>
      </GoogleMap>
    );
  }
}

IrisMap.propTypes = {
  address: PropTypes.object.isRequired,
  google: PropTypes.object
};

export default googleApiWrapper({
  apiKey: API_KEY
})(IrisMap);
